import {
  Typography,
  Paper,
  Grid,
  Select,
  MenuItem,
  Button,
  FormControl,
  Autocomplete,
  TextField,
  InputLabel, Table, TableBody, TableCell, TableRow
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export const RotationTableModal = ({
  employeeInfo,
  toggleModal,
  shiftsInfo,
	editData,
	getRotationData,
  setEditUser,
}) => {
  const [emp, setEmp] = useState(null);
  const absentReasons = useSelector(
    (state) => state.dashboardReducer.AbsentReasonAll
  );
  const [params] = useSearchParams();
  const date = moment(params.get('date') || new Date());

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isDirty, isValid },
		trigger,
  } = useForm({
    defaultValues: {
      shift: '',
      ptoType: '',
    },
    mode: 'onChange',
  });

  useEffect(() => {
    const getEmployee = async () => {
      try {
        const data = await ApiService.post('/getEmployees', {
          EmpIds: [employeeInfo],
          date: date.format('YYYY-MM-DD'),
        });
        setEmp(data[0]);
      } catch (error) {
        console.error(error);
      }
    };

    getEmployee();
  }, []);

	useEffect(() => {
		setValue('shift', editData.shift_Code[0], {
			shouldValidate: true,
			shouldDirty: true,
		});
	}, [editData, setValue]);

  const onSubmit = async (formData) => {
    try {
			if(editData.shift_Code[0] !== formData.shift){
				toast.error("Please choose same shift")
			}
			else{
				const selectedShift = shiftsInfo.find(
        (s) => Number(s.shiftCode) === Number(formData.shift)
				);

				const requestData = {
					EmpCode: employeeInfo,
					RequestDate: date.format('YYYY-MM-DD'),
					// ShiftCode: formData.shift,
					ShiftCode: parseInt(formData.shift, 10),
					SelAbsent: formData.ptoType,
					SelEmp: '',
					EndTime: selectedShift ? selectedShift.endTime : '',
					StartTime: selectedShift ? selectedShift.startTime : '',
				};

				await ApiService.post('/postAdminAddOvertime', { ...requestData });

				toast.success('Successfully saved!', { position: 'top-right' });
				toggleModal();
				getRotationData();
			}
    } catch (error) {
      console.error('Error saving time off:', error);
      toast.error('Failed to save time off', { position: 'top-right' });
    }
  };

  return (
    <>
      <Button sx={{ mb: 2 }} style={{ color: '#555555'}} 
        onClick={
          () => {
            toggleModal();
            setEditUser('');
          }
        }
      >
        <ArrowBackIosIcon/> Back 
      </Button>

      <Typography variant="h6" fontWeight={700} gutterBottom>
        {date.format('dddd Do MMMM YYYY')}
      </Typography>

      <Paper
        variant="outlined"
        sx={{ p: 2, my: 2, borderColor: '#e0e0e0', backgroundColor: '#fafafa' }}
      >
        <Typography color="error" fontWeight={700}>
          Selected Members
        </Typography>
        <Typography>
          {emp ? `${emp.employee_assignment.EA_Rank} ${emp.fullName}` : ''}
        </Typography>
      </Paper>

      {editData?.absentData?.absent_code?.SO_Desc &&
        <div className='my-2'>
          <Typography fontWeight={700} fontSize={21}>Existing PTO</Typography>
            <PTODelete 
              editData={editData}
              getRotationData={getRotationData}
              toggleModal={toggleModal}
            />
        </div>}

    {!editData?.absentData?.absent_code?.SO_Desc &&
      <>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Add Time Off
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!errors.shift}>
              <InputLabel>Shift</InputLabel>
              <Select
                label="Shift"
                {...register('shift', {
                  required: 'Shift is required',
                })}
                onChange={(e) =>
                  setValue('shift', e.target.value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  })
                }
								defaultValue={editData?.shift_Code[0]}
              >
                {shiftsInfo &&
                  shiftsInfo.map((shift) => (
                    <MenuItem key={shift.shiftCode} value={shift.shiftCode}>
                      {shift.title}
                    </MenuItem>
                  ))}
              </Select>
              {errors.shift && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: 'block' }}
                >
                  {errors.shift.message}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!errors.ptoType}>
              <InputLabel>PTO Type</InputLabel>
              <Select
                label="PTO Type"
                {...register('ptoType', {
                  required: 'PTO Type is required',
                })}
                onChange={(e) =>
                  setValue('ptoType', e.target.value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  })
                }
              >
                {Object.entries(absentReasons).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
              {errors.ptoType && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: 'block' }}
                >
                  {errors.ptoType.message}
                </Typography>
              )}
            </FormControl>
          </Grid>
        </Grid>

        <ButtonTheme
          type="submit"
					color="primary"
					className = "mt-3"
          disabled={!isDirty || !isValid || !editData.shift_Code}
        >
          Save
        </ButtonTheme>
      </form>
      </>}
    </>
  );
};


export const PTODelete = ( { editData , getRotationData , toggleModal }) => {

  const [employees, setEmployees] = useState([])
  const [assignedTo, setAssignedTo] = useState(null)

  let deleteShift = (data) => {
		ApiService.delete(`/deleteEmployeesOvertime?ShiftNumber[]=${data?.absentData?.Shift_Number}&FillEmp=false&type=${data?.absentData?.Absent_Code}&date=${data?.absentData?.Shift_Date}`)
			.then((data) => {
				toast.success('Shift deleted Successfully');
        toggleModal();
        getRotationData();
			}
		)
	};

  const loadEmployees = () => {
      ApiService.get('/employees-list?search=')
        .then(({ data }) => {
          var tempArr = []
          data.data.map((emp) => {
            var obj = emp
            obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
            tempArr.push(obj)
          })
          setEmployees(tempArr)
        })
        .catch((e) => {
          console.error(e?.error)
        })
    }

  const savePTO = (data) => {
    const body = {
      "ShiftNumber": [data?.absentData?.Shift_Number],
      "FillEmp": assignedTo?.Emp_Code,
      "type": data?.absentData?.Absent_Code,
      "status": "F",
      "date": data?.absentData?.Shift_Date,
      "SelEmp": "",
      "Comment": ""
    }
    ApiService.post('/editEmployeesOvertime', body)
      .then((data) => {
        toast.success(data.message)
        toggleModal();
        getRotationData();
      })
      .catch((error) => {
          toast.error(error?.data?.message);
      })
    }

    useEffect(() => {
      loadEmployees()
    }, [])

  return <>
        <div style={{ marginTop: '10px' , display:'flex' , justifyContent:'space-between'}}>
          {editData?.absentData?.absent_code?.SO_Desc &&
            <div>
              <p style={{marginBottom:'4px'}}>PTO Type</p>
                <div style={{border: '1px solid rgba(224, 224, 224, 1)', borderRadius: '8px' , width:'384px' , padding:'10px'}}>
                  {editData?.absentData?.absent_code?.SO_Desc}
                </div>
            </div>
          }

          {editData?.absentData?.absent_code?.SO_Desc &&
            <div>
              <p style={{marginBottom:'4px'}}>Shift</p>
                <div style={{border: '1px solid rgba(224, 224, 224, 1)', borderRadius: '8px' , width:'375px' , padding:'10px'}}>
                  {editData?.shifts}
                </div>
            </div>
          }

        </div>

          {editData?.absentData?.absent_code?.SO_Desc &&
            <Grid item md={6} style={{marginTop:'10px'}}>
              <p style={{marginBottom:'4px'}}>Employee to fill</p>
              <Autocomplete
                  options={employees}
                  value={assignedTo}
                  onChange={(event, newValue) => { setAssignedTo(newValue) }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "48px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center"
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Employee"
                    />
                  )}
                />
            </Grid>}

        {editData?.absentData?.absent_code?.SO_Desc &&
        <div className='d-flex my-3' style={{gap: '10px'}}>
          <ButtonTheme variant="filled" color='primary' className='px-5' disabled={assignedTo == null} onClick={() => {savePTO(editData)}}>
            Save
          </ButtonTheme>

          <ButtonTheme variant="filled" color='primary' className='px-5' disabled={editData?.absentData?.absent_code == null} onClick={() => deleteShift(editData)}>
            Delete
          </ButtonTheme>
        </div>}
  </>
}
